import { render, staticRenderFns } from "./SalesAgents.vue?vue&type=template&id=09dc21e4&scoped=true&"
import script from "./SalesAgents.vue?vue&type=script&lang=ts&"
export * from "./SalesAgents.vue?vue&type=script&lang=ts&"
import style0 from "./SalesAgents.vue?vue&type=style&index=0&id=09dc21e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dc21e4",
  null
  
)

export default component.exports